import React, { useReducer, useState, useEffect } from 'react'

import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Divider,
    Box,
    FormGroup,
    FormControlLabel,
    Switch
} from '@mui/material'

import LoadingButton from '@mui/lab/LoadingButton'

import CloseIcon from '@mui/icons-material/Close'

import InputAdornment from '@mui/material/InputAdornment';

import TooltipIndicators from '../../../Dash/Tooltip'

import { lockedReducer } from '../../../../utils/defaultReducer'

export default function AddBotDialog({ data, handleClose, submit, onEdit, userEmail="" }) {

    const [state, setState] = useReducer(lockedReducer, {
        id            : 0,
        imap_username : '',
        imap_password : '',
        imap_server   : '',
        imap_port     : 993,
        imap_ssl      : 1,
        smtp_username : userEmail,
        smtp_password : '',
        smtp_server   : '',
        smtp_port     : 465,
        smtp_ssl      : 1,
        from_address  : '',
        from_name     : '',
        smtp_skip_verify: 0,
        exceptions    : '',
        inbound       : ! userEmail,
        filter_promotional: 0,
    })
    const [useOtherCredentials, setUseOtherCredentials] = useState(false)

    useEffect(()=>{
        if (data.id){
            setState({
                ...data,
                imap_password: '**********',
                smtp_password: '**********'
            })
            if (data.smtp_username && data.imap_username && data.smtp_username !== data.imap_username) {
                setUseOtherCredentials(true)
            }
        }
    }, [data])

    return (
        <div>
            <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={true}
                disablePortal
                disableEnforceFocus
                sx={{ position: 'absolute' }}
            >
                <DialogTitle className="group-flexbox">
                    {data.id ? 'Editar': 'Adicionar'} conta de e-mail
                    <Button onClick={() => window.open("https://instant.getoutline.com/s/kwik-integracoes/doc/integracao-com-e-mail-v5RCr1SG2H", "_blank")}>FAQ</Button>
                    {/*<Button sx={{ 'minWidth': '2rem', 'padding': '0' }} onClick={handleClose}>
                        <CloseIcon />
                    </Button>*/}
                </DialogTitle>
                <Divider />
                <DialogContent className="add-bot-dialog-content">
                    {! userEmail &&
                        <FormGroup>
                            <FormControlLabel disabled={data.id} control={
                                <Switch
                                    color="primary"
                                    checked={state.inbound}
                                    onChange={() => setState({ inbound: ! state.inbound })}
                                />
                            }
                                label="Com leitura automática da caixa de entrada?" />
                        </FormGroup>
                    }

                    {state.inbound &&
                        <>
                            <TextField
                                size="small"
                                label="Email IMAP"
                                fullWidth
                                type="text"
                                variant="outlined"
                                value={state.imap_username}
                                onChange={(e) => setState({ imap_username: e.target.value })}
                                disabled={data.id}
                            />
                            <TextField
                                size="small"
                                label="Senha IMAP"
                                fullWidth
                                type="password"
                                variant="outlined"
                                value={state.imap_password}
                                onChange={(e) => setState({ imap_password: e.target.value })}
                            />
                            <TextField
                                size="small"
                                label="Servidor IMAP"
                                fullWidth
                                type="text"
                                variant="outlined"
                                value={state.imap_server}
                                onChange={(e) => setState({ imap_server: e.target.value })}
                            />
                            <TextField
                                size="small"
                                label="Porta IMAP"
                                fullWidth
                                type="text"
                                variant="outlined"
                                value={state.imap_port}
                                onChange={(e) => setState({ imap_port: e.target.value })}
                            />

                            <Box className='BuilderBotSelectorBox'>
                                <Button
                                    variant={state.imap_ssl ? 'contained' : ''}
                                    onClick={() => setState({ imap_ssl: 1 })}
                                >
                                    SSL
                                </Button>
                                <Button
                                    variant={!state.imap_ssl ? 'contained' : ''}
                                    onClick={() => setState({ imap_ssl: 0 })}
                                >
                                    SEM SSL
                                </Button>
                            </Box>

                            <FormGroup>
                                <FormControlLabel disabled={data.id} control={
                                    <Switch
                                        color="primary"
                                        checked={useOtherCredentials}
                                        onChange={() => setUseOtherCredentials(p => !p)}
                                    />
                                }
                                label="Usa credenciais diferentes de imap e smtp?" />
                            </FormGroup>
                        </>
                    }

                    {(! state.inbound || useOtherCredentials) &&
                        <>
                            <TextField
                                size="small"
                                label="Usuário SMTP"
                                fullWidth
                                type="text"
                                variant="outlined"
                                value={state.smtp_username}
                                onChange={(e) => setState({ smtp_username: e.target.value })}
                                disabled={data.id || userEmail}
                            />
                            <TextField
                                size="small"
                                label="Senha SMTP"
                                fullWidth
                                type="password"
                                variant="outlined"
                                value={state.smtp_password}
                                onChange={(e) => setState({ smtp_password: e.target.value })}
                            />
                        </>
                    }

                    <TextField
                        size="small"
                        label="Endereço do remetente"
                        fullWidth
                        type="text"
                        variant="outlined"
                        value={state.from_address}
                        onChange={(e) => setState({ from_address: e.target.value })}
                        helperText="Opcional. Se não informado, será utilizado o usuário SMTP."
                    />
                    <TextField
                        size="small"
                        label="Nome do remetente"
                        fullWidth
                        type="text"
                        variant="outlined"
                        value={state.from_name}
                        onChange={(e) => setState({ from_name: e.target.value })}
                    />

                    <TextField
                        size="small"
                        label="Servidor SMTP"
                        fullWidth
                        type="text"
                        variant="outlined"
                        value={state.smtp_server}
                        onChange={(e) => setState({ smtp_server: e.target.value })}
                    />
                    <TextField
                        size="small"
                        label="Porta SMTP"
                        fullWidth
                        type="text"
                        variant="outlined"
                        value={state.smtp_port}
                        onChange={(e) => setState({ smtp_port: e.target.value })}
                    />

                    <Box className='BuilderBotSelectorBox'>
                        <Button
                            variant={state.smtp_ssl ? 'contained' : ''}
                            onClick={() => setState({ smtp_ssl: 1 })}
                        >
                            SSL
                        </Button>
                        <Button
                            variant={!state.smtp_ssl ? 'contained' : ''}
                            onClick={() => setState({ smtp_ssl: 0 })}
                        >
                            SEM SSL
                        </Button>
                    </Box>

                    <FormGroup>
                        <FormControlLabel control={
                            <Switch
                                color="primary"
                                checked={state.smtp_skip_verify}
                                onChange={() => setState({ smtp_skip_verify: !state.smtp_skip_verify })}
                            />
                        }
                            label="Ignorar validação do certificado TLS?" />
                    </FormGroup>

                        <FormGroup>
                            <FormControlLabel control={
                                <Switch
                                    color="primary"
                                    checked={state.filter_promotional}
                                    onChange={() => setState({ filter_promotional: ! state.filter_promotional })}
                                />
                            }
                                label="Filtrar e-mails promocionais?" />
                        </FormGroup>
                </DialogContent>
                <DialogActions >
                    {Object.keys(data).length === 0 &&
                        <Box className="user-footer">
                            <LoadingButton className="button-created" onClick={handleClose}>
                                Cancelar
                            </LoadingButton>
                            <LoadingButton className="button-created"
                                onClick={() => {
                                    let sendData = { ...state }
                                    if (state.inbound && !useOtherCredentials) {
                                        sendData.smtp_username = state.imap_username
                                        sendData.smtp_password = state.imap_password
                                    }
                                    sendData.inbound = (state.inbound) ? 1 : 0
                                    submit(sendData)
                                }}
                                disabled={false}
                            >
                                Salvar
                            </LoadingButton>
                        </Box>
                    }
                    {data.id &&
                        <Box className="user-footer">
                            <LoadingButton className="button-created" onClick={handleClose}>
                                Cancelar
                            </LoadingButton>
                            <LoadingButton className="button-created"
                                onClick={() => {
                                    let sendData = { ...state }
                                    if (state.inbound && !useOtherCredentials) {
                                        sendData.smtp_password = state.imap_password
                                    }
                                    onEdit(sendData)
                                }}
                            >
                                Salvar
                            </LoadingButton>
                        </Box>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
}
